import { Component } from 'react';
import {actions, Form} from 'forms/rrf';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'react-bootstrap';
import SecurityQuestionAnswer from '../../../common/form/user/security-question-answer-input';
import PageTitle from '../../../common/page-title/index';
import BackLink from '../../../common/back-link/index';
import ArrowButton from '../../../common/button-arrow';
import {updateSecurityQuestionsForOwner} from '../../../../actions/update-security-questions';
import {getQuestions} from '../../../../actions/about-you';
import {getUserDetails} from '../../../../actions/users';

class UpdateSecurityQuestions extends Component {
  updateErrors = (field, value) => {
    this.setState({[field]: value});
  };
  onSaveClicked = (payload) => {
    this.props.dispatch(actions.submitFields('deep.updateSecQ.owner', updateSecurityQuestionsForOwner(this.id, payload)));
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  UNSAFE_componentWillMount() {
    const {dispatch} = this.props;
    this.id = +this.props.match.params.id;
    dispatch(getUserDetails(this.id))
      .then(() => {
        dispatch(actions.change(
          'deep.updateSecQ.owner.security_answers_attributes[0].id',
          this.props.user.relationships['security-answers'].data[0].id
        ));
        dispatch(actions.change(
          'deep.updateSecQ.owner.security_answers_attributes[1].id',
          this.props.user.relationships['security-answers'].data[1].id
        ));
      });
    this.props.dispatch(getQuestions());
  }

  render() {
    return (
      <Form
        model="deep.updateSecQ.owner"
        onSubmit={this.onSaveClicked}
      >
        <Container fluid className="update-security-questions">
          <Row>
            <Col lg={12}>
              <BackLink href={`/admin/users/${this.id}/details`}/>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <PageTitle>
                Update security questions
              </PageTitle>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <SecurityQuestionAnswer
                answerControlId="userSecurityAnswer1"
                answerModel=".security_answers_attributes[0].answer"
                questionControlId="userSecurityQuestion1"
                questionModel=".security_answers_attributes[0].security_question_id"
                questions={this.props.questions.filter(question => question.attributes['list-number'] === 1)}
              />

              <SecurityQuestionAnswer
                answerControlId="userSecurityAnswer2"
                answerLabel="Security answer 2"
                answerModel=".security_answers_attributes[1].answer"
                answerPlaceHolder="Security answer 2"
                questionControlId="userSecurityQuestion2"
                questionLabel="Security question 2"
                questionModel=".security_answers_attributes[1].security_question_id"
                questions={this.props.questions.filter(question => question.attributes['list-number'] === 2)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ArrowButton
                arrow={false}
                className="float-end"
                color="red"
              >
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Container>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  questions: state.aboutYou.questions,
  user: state.users.user,
});

export default connect(mapStateToProps)(UpdateSecurityQuestions);
